// src/components/planning/EditReadingsModal/components/ConfirmationModal.tsx
import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { ConfirmationModalProps } from './types';

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  show,
  onHide,
  onConfirm
}) => (
  <Modal show={show} onHide={onHide}>
    <Modal.Header closeButton>
      <Modal.Title>Confirm Update</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      Are you sure you want to update these readings? This action cannot be undone.
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onHide}>
        Cancel
      </Button>
      <Button variant="primary" onClick={onConfirm}>
        Confirm Update
      </Button>
    </Modal.Footer>
  </Modal>
);